exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TopRight-module__wrapper___1Zut5{display:grid;grid-auto-flow:column;gap:.75rem}.TopRight-module__wrapper___1Zut5 .TopRight-module__delete___3FkRu{color:#fc156d}.TopRight-module__wrapper___1Zut5 .TopRight-module__mail___3APte{color:#0827e9}.TopRight-module__wrapper___1Zut5 button{display:block;font-size:14px}", ""]);

// exports
exports.locals = {
	"wrapper": "TopRight-module__wrapper___1Zut5",
	"delete": "TopRight-module__delete___3FkRu",
	"mail": "TopRight-module__mail___3APte"
};